import { render, staticRenderFns } from "./InHospitalStock.vue?vue&type=template&id=38ace863&scoped=true&"
import script from "./InHospitalStock.vue?vue&type=script&lang=ts&"
export * from "./InHospitalStock.vue?vue&type=script&lang=ts&"
import style0 from "./InHospitalStock.vue?vue&type=style&index=0&id=38ace863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ace863",
  null
  
)

export default component.exports